
app.controller('dialog_add2FaCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
    
        $scope.gui = {};
        $scope.gui.okButtonDisabled = true;
        $scope.gui.qrsrc = "";
        
        $rootScope.$on("add2FaDialog", function(){
            NetworkService.callOperation("gettwofaqr", {}, function(d){
                console.log($scope.gui)
                $scope.gui.qrsrc = d.get("qr");
             })
        })
        
    }])